import React from 'react';
import Navigation from '../components/Navigation';
import CFPForm from '../components/CFPForm';
import SpeakerIncentives from '../components/SpeakerIncentives';
import SmallHero from '../components/SmallHero';

const CallForPapers: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-gray-50">
      <Navigation />
      <SmallHero 
        title="Call for Speakers" 
        subtitle="Share your expertise at Europe's Premier Language Intelligence Conference. We welcome submissions from industry leaders, researchers, and practitioners."
      />
      <div className="max-w-7xl mx-auto py-12 px-4">
        {/* Incentives Section */}
        <SpeakerIncentives />

        {/* CFP Form */}
        <div className="mt-12">
          <CFPForm />
        </div>
      </div>
    </div>
  );
};

export default CallForPapers;
